var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#87CBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.333 12.0003V14.017C26.3556 14.3051 26.3154 14.5946 26.2154 14.8657C26.1153 15.1368 25.9577 15.383 25.7533 15.5873C25.549 15.7916 25.3028 15.9493 25.0317 16.0493C24.7606 16.1494 24.4711 16.1895 24.183 16.167H21.333V10.342C21.335 9.89692 21.5132 9.47077 21.8287 9.15684C22.1442 8.8429 22.5713 8.66677 23.0163 8.66699C23.8978 8.6703 24.7421 9.02308 25.3638 9.64797C25.9856 10.2728 26.3341 11.1188 26.333 12.0003Z",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66699 19.917V12.8337V12.0003C9.66699 10.1587 10.5003 8.66699 13.0003 8.66699H23.0003C22.5587 8.66831 22.1355 8.84433 21.8233 9.1566C21.511 9.46888 21.335 9.89204 21.3337 10.3337V24.5003C21.3337 24.6551 21.2906 24.8068 21.2092 24.9384C21.1278 25.0701 21.0114 25.1765 20.873 25.2457C20.7346 25.3149 20.5796 25.3442 20.4255 25.3303C20.2714 25.3164 20.1241 25.2598 20.0003 25.167L18.5753 24.1003C18.4162 23.9798 18.2188 23.9209 18.0196 23.9347C17.8204 23.9485 17.633 24.034 17.492 24.1753L16.092 25.5753C15.9347 25.7315 15.722 25.8191 15.5003 25.8191C15.2787 25.8191 15.066 25.7315 14.9087 25.5753L14.2503 24.917",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 22.8333C14.6679 23.4393 14.5005 24.0337 14.1833 24.55C13.8886 25.0428 13.4711 25.4508 12.9715 25.7341C12.472 26.0174 11.9076 26.1663 11.3333 26.1663C10.7591 26.1663 10.1946 26.0174 9.69513 25.7341C9.19561 25.4508 8.7781 25.0428 8.48334 24.55C8.16616 24.0337 7.99882 23.4393 8.00001 22.8333C8.00001 21.9493 8.3512 21.1014 8.97632 20.4763C9.60144 19.8512 10.4493 19.5 11.3333 19.5C12.2174 19.5 13.0652 19.8512 13.6904 20.4763C14.3155 21.1014 14.6667 21.9493 14.6667 22.8333Z",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.575 22.8174H10.0917",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3329 21.5996V24.0913",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.167 12.833H18.8337",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13 16.166H18",
    stroke: "#87CBFE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.f17b90ebe8b910e4e9508f6030916688.svg";
export { ForwardRef as ReactComponent };